var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loading
      ? _c(
          "div",
          [
            _c(
              "b-form",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Complaint ID",
                              "label-for": "complaint-id",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "complaint-id",
                                type: "text",
                                readonly: "",
                              },
                              model: {
                                value: _vm.complaint.complaintReference,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.complaint,
                                    "complaintReference",
                                    $$v
                                  )
                                },
                                expression: "complaint.complaintReference",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Customer", "label-for": "cust" } },
                          [
                            _c("b-form-input", {
                              attrs: { id: "cust", type: "text", readonly: "" },
                              model: {
                                value: _vm.complaint.leadClientName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.complaint, "leadClientName", $$v)
                                },
                                expression: "complaint.leadClientName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-for": "salesperson",
                              label: "Assigned to",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-label-group" },
                              [
                                _c("b-form-select", {
                                  attrs: { options: _vm.optionsSalesPerson },
                                  model: {
                                    value: _vm.complaint.salespersonId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.complaint,
                                        "salespersonId",
                                        $$v
                                      )
                                    },
                                    expression: "complaint.salespersonId",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Status", "label-for": "status" } },
                          [
                            _c("b-form-select", {
                              attrs: {
                                id: "status-select",
                                options: _vm.statusOptions,
                                required: "",
                              },
                              model: {
                                value: _vm.complaint.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.complaint, "status", $$v)
                                },
                                expression: "complaint.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-for": "Open-date",
                              label: "Creation Date",
                            },
                          },
                          [
                            _c("b-form-datepicker", {
                              staticClass: "mb-1",
                              attrs: { id: "dueDate", disabled: "" },
                              model: {
                                value: _vm.complaint.openDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.complaint, "openDate", $$v)
                                },
                                expression: "complaint.openDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Due Date",
                              "label-for": "dueDate",
                            },
                          },
                          [
                            _c("b-form-datepicker", {
                              staticClass: "mb-1",
                              attrs: {
                                id: "dueDate",
                                required: "",
                                placeholder: "Select a date",
                              },
                              model: {
                                value: _vm.complaint.dueDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.complaint, "dueDate", $$v)
                                },
                                expression: "complaint.dueDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Priority",
                              "label-for": "priority-select",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                id: "priority-select",
                                options: _vm.priorityOptions,
                                required: "",
                              },
                              model: {
                                value: _vm.complaint.rating,
                                callback: function ($$v) {
                                  _vm.$set(_vm.complaint, "rating", $$v)
                                },
                                expression: "complaint.rating",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Complaint Comment:",
                              "label-for": "Description",
                            },
                          },
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                id: "textarea-default",
                                placeholder: "Comment",
                                rows: "3",
                                required: "",
                              },
                              model: {
                                value: _vm.complaint.feedbacks[0].description,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.complaint.feedbacks[0],
                                    "description",
                                    $$v
                                  )
                                },
                                expression:
                                  "complaint.feedbacks[0].description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "justify-content-end d-flex",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary" },
                            on: { click: _vm.updateComplaint },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }